import React from 'react';
import '../ArticoloCanvas/articolo-canvas.css';
import './galleria-canvas.css'

const GalleriaCanvas = ({photos}) => {
  return (
    <div className="canvas-container">
        <div className="big-container">
            <div className="title-box">
                <h1>Galleria</h1>
                <h3>Clicca sulle immagini per ingrandirle</h3>
            </div>
            <div className="photo-card-container">
                {photos.map((foto)=>(
                    <div key={foto.id} className="photo-card">
                        <a href={foto.link} target="_blank" rel="noopener noreferrer">
                            <img src={foto.link} alt={foto.title} className="photo-thumbnail" />
                        </a>
                        <div className="rightText">
                            <h4>{foto.title}</h4>
                            <p>{foto.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default GalleriaCanvas